export default __webpack_public_path__ + "static/green_pin-07e5f5972edc409d2f00f1233d534b3b.png";